import type { FaireThemeEntity } from "../../entity_types/theme";

export const modern_minimalist_jewelry: FaireThemeEntity = {
  token: "modern-minimalist-jewelry",
  type: "theme",
  name: "Modern Minimalist Jewelry",
  description: "Clean lines and small-batch craftsmanship for the modern woman. These necklaces and bracelets are perfect for layering or wearing as subtle standalone pieces.",
  teaser: "Your store's focus on clothing and beauty pairs perfectly with minimalist jewelry that doesn't overwhelm an outfit. These pieces are versatile enough to suit any customer's personal style.",
  detail: "The products you spent the most time viewing, such as the Evereign Knot Necklace and the Oval CZ Studs, are described as minimalist and bohemian, fitting a curated boutique aesthetic.",
  bgColor: "#B0C4D4",
  tileBgColor: "#3a4c6b",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_4bzxyssm4s",
    "p_46ynjt9tmy",
    "p_xfv6fgb39w",
    "p_k4mqhkwcra",
    "p_nkjxkbqaz9",
    "p_85zuvdfqvw",
    "p_kjbf9x9spe",
    "p_qmugvp9ke7",
    "p_57hu4dvfkp",
    "p_h729mty5gg",
    "p_ut3tbs6mrw",
    "p_chad2wxj78",
    "p_5xedx5mreu",
    "p_bn3ggn39hu",
    "p_36j2ps3emg",
    "p_ar6ja253qt",
    "p_cajty4ap3z",
    "p_tpt5wb4n2m",
    "p_zp787c5sfh",
    "p_3cq7ymywmu",
    "p_nrg5hxcuy3",
    "p_8k343bxac8",
    "p_pqf2f49nzz",
    "p_8uquc4add9",
    "p_dvc55z5255",
    "p_8e5qgj54en",
    "p_qwdhmgztnr",
    "p_en52fkxk94",
    "p_8pxfmcv78n",
    "p_tpf2apke3k",
    "p_aa34b8d4m9",
    "p_yqzdgu42f2",
    "p_xrscdcxcpu",
    "p_rc7vr9c3up",
    "p_uavgd4t79v",
    "p_b77fdhuyjs",
    "p_96uh69v26n",
    "p_djy9d9zpzv",
    "p_df7dvfex6j",
    "p_q55yjqh48v",
    "p_ngjxjhxerv",
    "p_qmzks9q3d3",
    "p_bd5jhepre3",
    "p_7dmudjnprg",
    "p_zta8n9x7js",
    "p_kaypw4deyb",
    "p_55xmcrzfva",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
